import React, { useState, useEffect } from "react";
import "./Master.css";
import Select from "react-select";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
  DeleteServiceCaller,
} from "../../../services/serviceCaller";
import { useAsyncError, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { Modal, Button } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { PhoneInput } from "react-international-phone";
import DeleteModal from "../../../components/DeletePopUpComponent";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const ClientMasterForm = () => {
  const { id } = useParams();
  const navHeading = id ? `Edit Client Master` : `Add Client Master`;

  const initialFormData = {
    Name: "",
    Code: "",
    PinCode: "",
    MobileNo1: "",
    Email: "",
    GSTNo: "",
    GSTEffectiveDate: "",
    CustomerType_030: "",
    IsInActive: "",
    InvoiceNo: "",
    StartDate: "",
    EndDate: "",
    DomainID: "",
    AccountManager: "",
    Description: "",
    RomID: "",
    LocationType: "",
    ManagerId: "",

    // "AddressType_024" : 1,
    AddressLine1: "",
    PANNo: "",
    CityID: "",
    RegionID: "",
    CountryID: "",
    StateID: "",
    relation: [
      {
        LineNo: 1,
        RelationType_025: 1611,
        RefContactName: "",
        RefContactMobile: "",
        RefContactEmail: "",
        RefContactDesignation: "",
        RefContactDepartment: "",
        Remarks: "",
        ContactID: "",
      },
    ],
    clientReferenceManagers: [
      {
        LineNo: 1,
        TypeId: "",
        ManagerId: "",
        FromDate: "",
        ToDate: "",
        ClientID: "",
      },
    ],
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading(navHeading));
    fetchSkills();
  }, []);
  useEffect(() => {
    if (id) {
      fetchSkillsId(id);
    }
  }, [id]);
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);

  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [nestAllEmployee, setnestAllEmployeeOptions] = useState([]);
  const [locationtype, setLoactionType] = useState([]);
  const [romOptions, setRomOptions] = useState([]);
  const [managerTypeOption, setManagerTypeOption] = useState([]);
  const [domainOptions, setDomainOptions] = useState([]);
  const [regionoption, setRegionoption] = useState([]);
  const [countryOption, setCountryoption] = useState([]);
  console.log("countryOption", countryOption);

  const [showError, setShowError] = useState(false);
  const [stateOption, setStateOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteType, setDeleteType] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    let isValid = true;

    // Validation rules
    if (name === "MobileNo1") {
      isValid = /^\d{0,10}$/.test(value); // MobileNo1: Allow only up to 10 digits
    } else if (name === "Name") {
      // Check if Name is not empty, but skip type checks
      isValid = value.trim() !== ""; // Only required validation
      if (!isValid) {
        setErrors((errors) => ({
          ...errors,
          [name]: "Name is required.",
        }));
      }
    } else if (name === "PinCode") {
      // Check if PinCode is required and not empty
      if (value.trim() === "") {
        isValid = false;
        setErrors((errors) => ({
          ...errors,
          [name]: "PinCode is required.",
        }));
      }
    }

    if (isValid) {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear the error message for valid input
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((errors) => ({
        ...errors,
        [name]: name === "PinCode" ? "PinCode is required." : "",
      }));
    }

    // Additional check for MobileNo1 to ensure it's exactly 10 digits
    if (name === "MobileNo1" && value?.length > 0 && value?.length < 10) {
      setErrors((errors) => ({
        ...errors,
        [name]: "Mobile number must be exactly 10 digits.",
      }));
    }
  };

  const handlePOCChange = (e, index) => {
    const { name, value } = e?.target;
    const updatedRelation = formData?.relation?.map((item, idx) =>
      idx === index ? { ...item, [name]: value } : item
    );

    // General validation flag
    let isValid = true;

    // Validate name for alphabetic characters
    if (name === "RefContactName") {
      isValid = /^[a-zA-Z\s]*$/.test(value);
      if (!isValid) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [index]: {
            ...prevErrors[index],
            RefContactName: "Only alphabetic characters are allowed.",
          },
        }));
      }
    }

    // Validate mobile number format (if applicable)
    if (name === "RefContactMobile" && !/^\d{10}$/.test(value)) {
      isValid = false;
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: {
          ...prevErrors[index],
          RefContactMobile: "Mobile number must be 10 digits.",
        },
      }));
    }

    // Update form data and clear errors if valid
    if (isValid) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        relation: updatedRelation,
        [name]: value,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: { ...prevErrors[index], [name]: "" }, // Clear specific error message
      }));
    } else {
      // Update form data regardless of validity
      setFormData((prevFormData) => ({
        ...prevFormData,
        relation: updatedRelation,
      }));
    }
  };

  const handleROMChange = (e, index) => {
    const { name, value } = e?.target;

    // Create a new array with updated data
    const updatedRelation = formData.clientReferenceManagers.map((item, idx) =>
      idx === index ? { ...item, [name]: value } : item
    );

    // Update the formData state with the new array
    setFormData((prevFormData) => ({
      ...prevFormData,

      clientReferenceManagers: updatedRelation,
    }));
  };

  const handleRomSelectChange = (option, name, index) => {
    const updatedRelation = formData.clientReferenceManagers.map((item, idx) =>
      idx === index ? { ...item, [name]: option.value } : item
    );

    // Create a new errors object to track validation errors
    const newErrors = {};
    let isValid = true; // Declare isValid variable

    // Validate ManagerId
    if (name === "ManagerID") {
      // Adjust the regex to match only numeric characters
      isValid = /^[0-9]*$/.test(option?.value);
      if (!isValid) {
        newErrors[index] = {
          ...newErrors[index],
          ManagerId: "Only numeric characters are allowed.",
        };
      }
    }

    // Validate TypeId
    if (name === "TypeID") {
      // Adjust the regex to match only numeric characters
      isValid = /^[0-9]*$/.test(option?.value);
      if (!isValid) {
        newErrors[index] = {
          ...newErrors[index],
          TypeID: "Only numeric characters are allowed.",
        };
      }
    }

    // Update the formData state with the new array
    setFormData((prevFormData) => ({
      ...prevFormData,
      clientReferenceManagers: updatedRelation,
    }));

    // Update errors state
    setErrors((prevErrors) => ({
      ...prevErrors,
      ...newErrors,
    }));

    // If the input is valid, clear the error message
    if (isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: { ...prevErrors[index], [name]: "" }, // Clear specific error message
      }));
    }
  };

  const fetchSkills = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}clientmaster`);
      if (response?.status === 200) {
        const cleanedData = response?.data?.data;
        const locationlist = Object?.entries(cleanedData?.location).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        setLoactionType(locationlist);

        const nestAllEMPOptions = cleanedData?.acManager?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        setnestAllEmployeeOptions(nestAllEMPOptions);
        const typeOption = cleanedData?.managerstype?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        setManagerTypeOption(typeOption);

        const RomOptions = cleanedData?.rom?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setRomOptions(RomOptions);
        const regionOpt = cleanedData?.region?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        setRegionoption(regionOpt);
        const countryOpt = cleanedData?.country?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        // setCountryoption(countryOpt);
        const stateOpt = cleanedData?.state?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        // setStateOption(stateOpt);
        const cityOpt = cleanedData?.city?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        // setCityOption(cityOpt);
        const DomainOptions = cleanedData?.domain?.map((record) => ({
          value: record?.value,
          label: record?.text,
        }));
        setDomainOptions(DomainOptions);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const fetchSkillsId = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}clientmaster/${id}`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;

        const formDataa = {
          Code: cleanedData?.contact?.Code,
          Name: cleanedData?.contact?.Name,
          PinCode: cleanedData?.contact?.PinCode,
          MobileNo1: cleanedData?.contact?.MobileNo1,
          Email: cleanedData?.contact?.Email,
          GSTNo: cleanedData?.contact?.GSTNo,
          GSTEffectiveDate:
            cleanedData.contact?.GSTEffectiveDate !== null &&
            cleanedData.contact?.GSTEffectiveDate !== undefined
              ? moment(cleanedData?.contact?.GSTEffectiveDate).format(
                  "DD-MMM-YYYY"
                )
              : "",

          CustomerType_030: cleanedData?.contact?.CustomerType_030,
          IsInActive: cleanedData?.contact?.IsInActive,
          AccountManager: cleanedData?.customers?.[0]?.AccountManager,
          RomID: cleanedData?.customers?.[0]?.RomID,
          InvoiceNo: cleanedData?.customers?.[0]?.InvoiceNo,
          StartDate:
            cleanedData.customers?.[0]?.StartDate !== null &&
            cleanedData.customers?.[0]?.StartDate !== undefined
              ? moment(cleanedData?.customers?.[0]?.StartDate).format(
                  "DD-MMM-YYYY"
                )
              : null,
          EndDate:
            cleanedData?.customers?.[0]?.EndDate !== null &&
            cleanedData?.customers?.[0]?.EndDate !== undefined
              ? moment(cleanedData?.customers?.[0]?.EndDate).format(
                  "DD-MMM-YYYY"
                )
              : null,
          DomainID: cleanedData?.customers?.[0]?.DomainID,
          // AccountManager: cleanedData?.contact?.AccountManager,
          Description: cleanedData?.contact?.Description,
          LocationType: cleanedData?.customers?.[0]?.LocationType,
          ManagerId: cleanedData?.contact?.ManagerId,

          // "AddressType_024" : 1,
          AddressLine1: cleanedData?.contactAddress?.[0]?.AddressLine1,
          PANNo: cleanedData?.contactAddress?.[0]?.PANNo,
          StateID: cleanedData.customers?.[0]?.StateID,
          CityID: cleanedData.customers?.[0]?.CityID,
          CountryID: cleanedData.customers?.[0]?.CountryID,
          RegionID: cleanedData.customers?.[0]?.RegionID,
          relation: cleanedData.contactRelation.map((ele, index) => ({
            LineNo: ele?.LineNo,
            ID: ele?.ID,
            RelationType_025: ele,
            RefContactName: ele.RefContactName,
            RefContactMobile: ele.RefContactMobile,
            RefContactEmail: ele.RefContactEmail,
            RefContactDesignation: ele.RefContactDesignation,
            RefContactDepartment: ele.RefContactDepartment,
            Remarks: ele.Remarks,
            ContactID: ele?.ContactID,
          })),
          clientReferenceManagers: cleanedData.clientreferencemanager
            .map((ele, index) => ({
              LineNo: ele?.LineNo,
              TypeId: ele?.TypeId,
              ManagerId: ele?.ManagerId,
              FromDate:
                ele?.FromDate !== null && ele?.FromDate !== undefined
                  ? moment(ele?.FromDate).format("DD-MMM-YYYY")
                  : null,
              ToDate:
                ele?.ToDate !== null && ele?.ToDate !== undefined
                  ? moment(ele?.ToDate).format("DD-MMM-YYYY")
                  : null,
              ClientID: ele?.ClientID,
              active:
                ele?.ToDate === null ||
                ele?.ToDate === undefined ||
                ele?.ToDate === ""
                  ? 0
                  : 1,
            }))
            .sort((a, b) => a.active - b.active),
        };
        setFormData(formDataa);
        if (cleanedData.customers?.[0]?.RegionID) {
          await fetchCountry(cleanedData.customers[0].RegionID);
        }
        if (cleanedData.customers?.[0]?.CountryID) {
          await fetchState(cleanedData.customers?.[0]?.CountryID);
        }
        if (cleanedData.customers?.[0]?.StateID) {
          await fetchCity(cleanedData.customers?.[0]?.StateID);
        }
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const handleAddPOCLine = () => {
    // Get the last row in the relation array
    const currentRow =
      formData.relation.length !== 0
        ? formData.relation[formData.relation.length - 1]
        : null;
    if (currentRow && currentRow.RefContactName === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Find the smallest missing line number
    let newLineNo = 1; // Start from 1
    const existingLineNos = formData.relation.map((row) => row.LineNo);

    // Check if there's any missing number in the sequence
    while (existingLineNos.includes(newLineNo)) {
      newLineNo++; // Increment until we find the first missing line number
    }
    setFormData((prevState) => ({
      ...prevState,
      relation: [
        ...prevState.relation,
        {
          LineNo: newLineNo,
          RelationType_025: 1611,
          RefContactName: "",
          RefContactMobile: "",
          RefContactEmail: "",
          RefContactDesignation: "",
          RefContactDepartment: "",
          Remarks: "",
        },
      ],
    }));
  };

  const handleAddROMLine = () => {
    // Get the last row in the clientReferenceManagers array
    const currentRow =
      formData.clientReferenceManagers.length !== 0
        ? formData.clientReferenceManagers[
            formData.clientReferenceManagers.length - 1
          ]
        : null;
    if (currentRow && currentRow.ManagerId === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Find the smallest missing line number
    let newLineNo = 1; // Start from 1
    const existingLineNos = formData.clientReferenceManagers.map(
      (row) => row.LineNo
    );

    // Check if there's any missing number in the sequence
    while (existingLineNos.includes(newLineNo)) {
      newLineNo++; // Increment until we find the first missing line number
    }
    // Add a new line with the correct line number
    setFormData((prevState) => ({
      ...prevState,
      clientReferenceManagers: [
        ...prevState.clientReferenceManagers,
        {
          TypeId: "",
          LineNo: newLineNo,
          ManagerId: "",
          FromDate: "",
          ToDate: "",
          active: 1,
        },
      ],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      try {
        // Validate InvoiceNo format
        if (
          formData.InvoiceNo &&
          !/^[A-Z]{3}_[a-zA-Z]{3,15}_\d{8}$/.test(formData.InvoiceNo)
        ) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            InvoiceNo:
              "Invoice number should follow the format: ABC_X_12345678.",
          }));
          setShowError(true);
          setLoading(false);
          return;
        }

        let response;
        if (id) {
          response = await PostServiceCaller(
            `${API_URL}clientmaster/${id}`,
            formData,
            "put"
          );
        } else {
          response = await PostServiceCaller(
            `${API_URL}clientmaster`,
            formData,
            "post"
          );
        }

        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setTimeout(() => {
            navigate("/client-master");
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
        }
      } catch (error) {
        console.error("Error while submitting data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error, { position: "top-right" });
          console.error("Server responded with status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      } finally {
        setLoading(false);
      }
    } else {
      // If there are validation errors, display them
      if (errors && Object.keys(errors).length > 0) {
        Object.values(errors).forEach((errorMessage) => {
          if (errorMessage) {
            toast.error(errorMessage, { position: "top-right" });
          }
        });
      }
    }
  };

  const handleDeletePOCLine = async (index, ID) => {
    if (ID) {
      // Checks if PocID is truthy (not null, undefined, or empty)
      try {
        await DeleteServiceCaller(
          `${API_URL}clientmaster-rompoc-delete/${ID}`,
          {},
          "delete"
        );
        const updatedLines = formData.relation.filter((_, i) => i !== index);
        setFormData({ ...formData, relation: updatedLines });
      } catch (error) {
        console.error("There was an error deleting the line!", error);
      }
    } else {
      // If PocID is falsy (null, undefined, or empty), just update the lines
      const updatedLines = formData.relation.filter((_, i) => i !== index);
      setFormData({ ...formData, relation: updatedLines });
    }
  };

  const handleDeleteRequest = async (lineNo, index) => {
    if (id) {
      try {
        await DeleteServiceCaller(
          `${API_URL}clientmaster-managerdetails-delete/${id}/${lineNo}`,
          {},
          "delete"
        );
        const updatedLines = formData.clientReferenceManagers.filter(
          (_, i) => i !== index
        );
        setFormData({ ...formData, clientReferenceManagers: updatedLines });
      } catch (error) {
        console.error("There was an error deleting the line!", error);
      }
    } else {
      const updatedLines = formData.clientReferenceManagers.filter(
        (_, i) => i !== index
      );
      setFormData({ ...formData, clientReferenceManagers: updatedLines });
    }
  };

  const openDeleteModal = (type, item) => {
    setShowDeleteModal(true);
    setSelectedDeleteItem(item);
    setDeleteType(type);
  };

  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      if (deleteType === "ROMLine") {
        handleDeleteRequest(
          selectedDeleteItem.LineNo,
          selectedDeleteItem.index
        );
      } else if (deleteType === "POCLine") {
        handleDeletePOCLine(selectedDeleteItem.index, selectedDeleteItem.ID);
      }
      setShowDeleteModal(false);
      setSelectedDeleteItem(null);
      setDeleteType("");
    }
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
    setDeleteType("");
  };
  const handleError = () => {
    setShowError(true);
  };
  const handleErrorClose = () => {
    setShowError(false);
  };

  const fetchCountry = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.StateCity;
        console.log("check cleanData", cleanedData);

        const Opt = cleanedData?.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setCountryoption(Opt);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Area Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Area Master:", error);
    }
  };
  const fetchState = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.StateCity;
        const Opt = cleanedData?.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setStateOption(Opt);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Area Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Area Master:", error);
    }
  };
  const fetchCity = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response.data.StateCity;
        const Opt = cleanedData?.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setCityOption(Opt);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Area Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Area Master:", error);
    }
  };

  const handleSelect = (e, name) => {
    const value = e.value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Update formData with the selected value
    }));

    if (name === "RegionID") {
      setFormData((prevState) => ({
        ...prevState,
        CountryID: null,
        StateID: null,
        CityID: null,
      }));
      fetchCountry(value);
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    } else if (name === "CountryID") {
      setFormData((prevState) => ({
        ...prevState,
        StateID: null,
        CityID: null,
      }));
      fetchState(value);
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    } else if (name === "StateID") {
      setFormData((prevState) => ({
        ...prevState,
        CityID: null, // Update formData with the selected value
      }));
      fetchCity(value);
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    } else if (name === "CityID") {
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    } else if (name === "DomainID") {
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    } else if (name === "RomID") {
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    } else if (name === "AccountManager") {
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    } else if (name === "LocationType") {
      setErrors((errors) => ({
        ...errors,
        [name]: "", // Clear error for valid selection
      }));
    }

    // Optional: Handle errors if no value is selected
    if (!value) {
      setErrors((errors) => ({
        ...errors,
        [name]: "This field must be selected.",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.Name) newErrors.Name = "Client Name is required";
    if (!formData.PinCode) newErrors.PinCode = "Zip Code is required";
    // if (!formData.CountryID) newErrors.CountryID = "Country is required";
    // if (!formData.StateID) newErrors.StateID = "State is required";
    // if (!formData.CityID) newErrors.CityID = "City is required";
    if (!formData.LocationType)
      newErrors.LocationType = "Location Type is required";
    if (!formData.RomID) newErrors.RomID = "RMG POC is required";
    if (!formData.AccountManager)
      newErrors.AccountManager = "Account Manager is required";
    if (!formData.DomainID) newErrors.DomainID = "Domain is required";

    // Validate relation array
    formData.relation.forEach((line, index) => {
      if (!line.RefContactName) {
        newErrors[`relation[${index}].RefContactName`] = "Poc Name is required";
      }
    });

    // Validate clientReferenceManagers array
    formData.clientReferenceManagers.forEach((line, index) => {
      if (!line.ManagerId) {
        newErrors[`clientReferenceManagers[${index}].ManagerId`] =
          "Manager Name is required";
      }
      if (!line.TypeId) {
        newErrors[`clientReferenceManagers[${index}].TypeId`] =
          "Manager Type is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
      <div className="Container">
        <form
          onSubmit={handleSubmit}
          id="formOne"
          className="rounded mt-2 bg-white"
        >
          {/** Tab Code Start */}
          <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                style={{ color: "#2F2E4B" }}
                id="clientMaster-tab"
                data-bs-toggle="tab"
                data-bs-target="#clientMaster"
                type="button"
                role="tab"
                aria-controls="clientMaster"
                aria-selected="true"
              >
                Client Details{" "}
                <span className="text-Primary">
                  {formData.Name?.trim() && `: ${formData.Name}`}
                </span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                style={{ color: "#2F2E4B" }}
                id="poc-tab"
                data-bs-toggle="tab"
                data-bs-target="#poc"
                type="button"
                role="tab"
                aria-controls="poc"
                aria-selected="false"
              >
                POC Details
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                style={{ color: "#2F2E4B" }}
                id="rom-tab"
                data-bs-toggle="tab"
                data-bs-target="#rom"
                type="button"
                role="tab"
                aria-controls="rom"
                aria-selected="false"
              >
                Manager Details
              </button>
            </li>
          </ul>
          {/** Tab Code End */}

          <div className="tab-content" id="myTabContent">
            {/** Main From Code start */}
            <div
              className="tab-pane fade show active"
              id="clientMaster"
              role="tabpanel"
              aria-labelledby="clientMaster-tab"
            >
              <div className="container-fluid mt-2">
                <div className="row">
                  <div className="col-md-3">
                    <label class="form-label">Client ID</label>
                    <input
                      readOnly
                      disabled
                      type="text"
                      className="form-control"
                      id="clientID"
                      name="clientID"
                      value={formData.Code}
                      placeholder="Client ID"
                      // onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">
                      Client Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Client Name"
                      className={`form-control ${
                        errors.Name ? "is-invalid" : ""
                      }`}
                      id="Name"
                      name="Name"
                      value={formData.Name}
                      onChange={handleChange}
                    />
                    <span class="error">{errors?.Name}</span>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Contact No.</label>
                    <input
                      // defaultCountry="in"
                      className="form-control"
                      name="MobileNo1"
                      value={formData.MobileNo1 || ""}
                      // onChange={(phone) =>
                      //   setFormData({
                      //     ...formData,
                      //     MobileNo1: phone && phone.length > 4 ? phone : "",
                      //   })
                      // }
                      onChange={handleChange}
                      placeholder="Contact No."
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Email ID</label>
                    <input
                      type="email"
                      className="form-control"
                      id="Email"
                      name="Email"
                      placeholder="Email ID"
                      value={formData.Email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      id="AddressLine1"
                      name="AddressLine1"
                      value={formData.AddressLine1}
                      onChange={handleChange}
                      placeholder="Address"
                    />
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      Region
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Select
                      name="RegionID"
                      // onChange={handleCountry}
                      // className={` ${errors.CountryID ? "is-invalid" : ""}`}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={regionoption.find(
                        (o) => o.value == formData.RegionID
                      )}
                      class="form-control"
                      options={regionoption}
                    />
                    {/* <span class="error">{errors?.CountryID}</span> */}
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      Country
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Select
                      name="CountryID"
                      // onChange={handleCountry}
                      // className={` ${errors.CountryID ? "is-invalid" : ""}`}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={countryOption.find(
                        (o) => o.value == formData.CountryID
                      ) || null}
                      class="form-control"
                      options={countryOption}
                    />
                    {/* <span class="error">{errors?.CountryID}</span> */}
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      State
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Select
                      name="StateID"
                      // onChange={handleState}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={
                        formData.StateID == null
                          ? ""
                          : stateOption.find((o) => o.value == formData.StateID)
                      }
                      // className={` ${errors.StateID ? "is-invalid" : ""}`}
                      class="form-control"
                      options={stateOption}
                    />{" "}
                    {/* <span class="error">{errors?.StateID}</span> */}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-3">
                    <label class="form-label">
                      City {/*<span className="text-danger">*</span> */}
                    </label>
                    <Select
                      name="CityID"
                      // onChange={handleCity}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={
                        formData.CityID == null
                          ? ""
                          : cityOption.find((o) => o.value == formData.CityID)
                      }
                      // className={` ${errors.CityID ? "is-invalid" : ""}`}
                      class="form-control"
                      options={cityOption}
                    />{" "}
                    {/* <span class="error">{errors?.CityID}</span> */}
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">
                      Zip Code<span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      // className="form-control"
                      className={`form-control ${
                        errors.PinCode ? "is-invalid" : ""
                      }`}
                      id="PinCode"
                      placeholder="Zip Code"
                      name="PinCode"
                      value={formData.PinCode}
                      onChange={handleChange}
                    />
                    <span class="error">
                      {errors.PinCode ? (
                        <span>{errors.PinCode}</span>
                      ) : (
                        <span>{errors.PinCode}</span>
                      )}
                    </span>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">GST/VAT #</label>
                    <input
                      type="text"
                      className="form-control"
                      id="GSTNo"
                      name="GSTNo"
                      placeholder="GST/VAT#"
                      value={formData.GSTNo}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">GST/VAT Date</label>
                    <CustomDatePicker
                      handleChange={handleChange}
                      value={formData.GSTEffectiveDate}
                      name="GSTEffectiveDate"
                      id="GSTEffectiveDate"
                      className="form-control"
                      placeholderText="DD-MMM-YYYY"
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <label className="form-label">PAN No. #</label>
                    <input
                      type="text"
                      className="form-control"
                      id="PANNo"
                      name="PANNo"
                      placeholder="Tax ID#"
                      value={formData.PANNo}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">NDA/MSA-Ref #</label>
                    <input
                      type="text"
                      placeholder="Format- NDA/MSA_ Name_DDMMYYYY"
                      className="form-control"
                      id="InvoiceNo"
                      name="InvoiceNo"
                      value={formData.InvoiceNo}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">
                      Location Type<span className="text-danger">*</span>
                    </label>
                    <Select
                      // className="form-select"
                      aria-label="Default select example"
                      id="LocationType"
                      name="LocationType"
                      value={locationtype.find(
                        (ele) => ele.value == formData?.LocationType
                      )}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      // onChange={(selected) => handleLoactionType(selected)}
                      options={locationtype}
                    />{" "}
                    <span class="error">{errors?.LocationType}</span>
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">Start Date</label>

                    <CustomDatePicker
                      handleChange={handleChange}
                      value={formData.StartDate}
                      name="StartDate"
                      id="StartDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      // maxDate={formData.EndDate} // Prevent StartDate from being after EndDate
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <label className="form-label">End Date</label>

                    <CustomDatePicker
                      handleChange={handleChange}
                      value={formData.EndDate}
                      name="EndDate"
                      id="EndDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      minDate={new Date(formData.StartDate)} // Prevent EndDate from being before StartDate
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">
                      Domain<span className="text-danger">*</span>
                    </label>
                    <Select
                      // className="form-select"
                      aria-label="Default select example"
                      id="DomainID"
                      name="DomainID"
                      value={domainOptions.find(
                        (ele) => ele.value == formData?.DomainID
                      )}
                      className={` ${errors.DomainID ? "is-invalid" : ""}`}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      // onChange={(selected) => handleDomian(selected)}
                      options={domainOptions}
                    />
                    <span class="error">{errors?.DomainID}</span>
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      Account Manager<span className="text-danger">*</span>
                    </label>
                    <Select
                      name="AccountManager"
                      // onChange={handleCountry}
                      className={` ${
                        errors.AccountManager ? "is-invalid" : ""
                      }`}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={romOptions.find(
                        (o) => o.value == formData.AccountManager
                      )}
                      class="form-control"
                      options={romOptions}
                    />
                    <span class="error">
                      {errors.AccountManager ? (
                        <span>{errors.AccountManager}</span>
                      ) : (
                        <span>{errors.AccountManager}</span>
                      )}
                    </span>
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      RMG POC<span className="text-danger">*</span>
                    </label>
                    <Select
                      name="RomID"
                      // onChange={handleCountry}
                      className={` ${errors.RomID ? "is-invalid" : ""}`}
                      onChange={(e, action) => handleSelect(e, action.name)}
                      value={romOptions.find((o) => o.value == formData.RomID)}
                      class="form-control"
                      options={romOptions}
                    />
                    <span class="error">
                      {errors.RomID ? (
                        <span>{errors.RomID}</span>
                      ) : (
                        <span>{errors.RomID}</span>
                      )}
                    </span>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3 ">
                    <label className="form-label">Remarks</label>
                    <textarea
                      placeholder="Remarks"
                      className="form-control"
                      name="Description"
                      onChange={handleChange}
                      value={formData.Description}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            {/** Main From Code End */}

            {/** Poc Table Code start */}

            <div
              className="tab-pane fade show p-2"
              id="poc"
              role="tabpanel"
              aria-labelledby="poc-tab"
            >
              {/* <PocDetailpage /> */}
              <div className="table-responsive poc-head rounded">
                <button
                  type="button"
                  onClick={handleAddPOCLine}
                  className="custom-btn-sm mb-2 pull-right"
                >
                  <i class="fa fa-plus"></i>&nbsp;Add
                </button>
                <Table
                  style={{ background: "#ECECEC !important" }}
                  // id="poctable_head"
                  className="table table-bordered"
                >
                  <thead id="thcolor" className="text-center align-middle  ">
                    <tr>
                      <th>Sr.  No.</th>
                      <th>
                        Name<span className="text-danger">*</span>
                      </th>
                      <th>Email ID</th>
                      <th>Designation</th>
                      <th>Department</th>
                      <th>Contact No.</th>
                      <th>Remarks</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.relation.map((ele, index) => (
                      <tr>
                        <td className="text-center align-middle">
                          {index + 1}
                        </td>
                        <td>
                          <input
                            type="text"
                            name="RefContactName"
                            value={ele?.RefContactName}
                            className={`form-control mx-auto ${
                              errors[index]?.RefContactName ? "is-invalid" : ""
                            }`}
                            onChange={(e) => handlePOCChange(e, index)}
                          />
                          {errors[index]?.RefContactName && ( // Accessing errors for the specific line
                            <div className="invalid-feedback text-center">
                              {errors[index].RefContactName}{" "}
                              {/* Displaying the error message */}
                            </div>
                          )}
                        </td>
                        <td>
                          <input
                            type="email"
                            name="RefContactEmail"
                            value={ele?.RefContactEmail}
                            className={`form-control mx-auto`}
                            onChange={(e) => handlePOCChange(e, index)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="RefContactDesignation"
                            value={ele?.RefContactDesignation}
                            className={`form-control mx-auto`}
                            onChange={(e) => handlePOCChange(e, index)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="RefContactDepartment"
                            value={ele?.RefContactDepartment}
                            className={`form-control mx-auto`}
                            onChange={(e) => handlePOCChange(e, index)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="RefContactMobile"
                            value={ele?.RefContactMobile}
                            // className={`form-control `}
                            className={`form-control mx-auto${
                              errors?.[index]?.RefContactMobile
                                ? "is-invalid"
                                : ""
                            }`}
                            onChange={(e) => handlePOCChange(e, index)}
                          />
                          <span className="error">
                            {errors?.[index]?.RefContactMobile ? (
                              <span>{errors?.[index]?.RefContactMobile}</span>
                            ) : (
                              <span>{errors?.[index]?.RefContactMobile}</span>
                            )}
                          </span>
                        </td>

                        <td>
                          <input
                            type="text"
                            name="Remarks"
                            value={ele?.Remarks}
                            className={`form-control mx-auto`}
                            onChange={(e) => handlePOCChange(e, index)}
                          />
                        </td>

                        <td className="text-center align-middle">
                          <div
                            type="button"
                            onClick={() =>
                              openDeleteModal("POCLine", { index, ID: ele.ID })
                            }
                          >
                            {/* {formData.lines.length > 1 && ( */}
                            <i
                              className="bi bi-trash"
                              style={{ fontSize: "1.2rem" }}
                            ></i>
                            {/* )} */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
            {/** Poc Table Code End */}

            {/** Rom Poc Table Code Start */}
            <div
              className="tab-pane fade show p-2"
              id="rom"
              role="tabpanel"
              aria-labelledby="rom-tab"
            >
              {/* <Rom /> */}

              <div className="table-responsive poc-head rounded">
                <button
                  type="button"
                  onClick={handleAddROMLine}
                  className="custom-btn-sm mb-2 pull-right"
                >
                  <i class="fa fa-plus"></i>&nbsp;Add
                </button>
                <Table
                  style={{ background: "#ECECEC !important" }}
                  className="table table-bordered"
                >
                  <thead id="thcolor" className="text-center align-middle">
                    <tr>
                      <th>Sr.No.</th>
                      <th>
                        Name<span className="text-danger">*</span>
                      </th>
                      <th>
                        Manager Type<span className="text-danger">*</span>
                      </th>
                      <th>
                        From Date<span className="text-danger">*</span>
                      </th>
                      <th>To Date</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.clientReferenceManagers.map((ele, index) => (
                      <tr key={index}>
                        <td className="text-center align-middle">
                          {index + 1}
                        </td>
                        <td>
                          <Select
                            name="ManagerId"
                            // isDisabled={ele?.active == 0}
                            value={
                              romOptions.find(
                                (option) => option.value === ele?.ManagerId
                              ) || null
                            }
                            className={`mx-auto select-dropdown ${
                              errors[index]?.ManagerId ? "is-invalid" : ""
                            }`}
                            menuPlacement="bottom"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 1050,
                              }),
                            }}
                            onChange={(option) =>
                              handleRomSelectChange(option, "ManagerId", index)
                            }
                            options={romOptions}
                          />
                          {errors[index]?.ManagerId && ( // Accessing errors for the specific line
                            <div className="invalid-feedback text-center">
                              {errors[index].ManagerId}
                              {/* Displaying the error message */}
                            </div>
                          )}
                        </td>
                        <td>
                          <Select
                            name="TypeId"
                            value={
                              managerTypeOption.find(
                                (option) => option.value === ele?.TypeId
                              ) || null
                            }
                            // isDisabled={ele?.active == 0}
                            className={`mx-auto select-dropdown ${
                              errors[index]?.TypeId ? "is-invalid" : ""
                            }`}
                            menuPlacement="bottom"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 1050,
                              }),
                            }}
                            onChange={(option) =>
                              handleRomSelectChange(option, "TypeId", index)
                            }
                            options={managerTypeOption}
                          />
                          {errors[index]?.TypeId && ( // Accessing errors for the specific line
                            <div className="invalid-feedback text-center">
                              {errors[index].TypeId}
                              {/* Displaying the error message */}
                            </div>
                          )}
                        </td>
                        <td>
                          <CustomDatePicker
                            handleChange={(e) => handleROMChange(e, index)}
                            value={ele.FromDate}
                            name="FromDate"
                            id="FromDate"
                            // readOnly={ele?.active == 0}
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                          />
                        </td>
                        <td>
                          <CustomDatePicker
                            handleChange={(e) => handleROMChange(e, index)}
                            value={ele.ToDate}
                            name="ToDate"
                            id="ToDate"
                            // readOnly={ele?.active == 0}
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                            minDate={new Date(ele.FromDate)}
                          />
                        </td>
                        <td className="text-center align-middle">
                          <div
                            type="button"
                            onClick={
                              ele?.active !== 0
                                ? () =>
                                    openDeleteModal("ROMLine", {
                                      index,
                                      LineNo: ele.LineNo,
                                    })
                                : undefined
                            }
                            style={{
                              cursor:
                                ele?.active === 0 ? "not-allowed" : "pointer",
                            }}
                            title={
                              ele?.active === 0
                                ? "Delete disabled for inactive item"
                                : "Delete this line"
                            }
                          >
                            <i
                              className={`bi bi-trash ${
                                ele?.active === 0 ? "disabled-icon" : ""
                              }`}
                              style={{
                                fontSize: "1.2rem",
                                // color: ele?.active === 0 ? "#ccc" : "#dc3545",
                                pointerEvents:
                                  ele?.active === 0 ? "none" : "auto",
                              }}
                            ></i>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
            {/** Rom Poc Table Code End */}
          </div>

          {/* End of dynamic rows */}
          <div className="d-flex justify-content-end">
            <div className="d-flex me-2">
              <div>
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() => navigate("/client-master")}
                >
                  Cancel
                </button>
              </div>
              <div>
                <button
                  disabled={loading ? true : false}
                  type="submit"
                  className="custom-btn"
                >
                  {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </form>

        <Modal show={showError} onHide={handleError} dialogClassName="modal-md">
          <div
            style={{ backgroundColor: "#" }}
            className="card rounded border-0 m-2"
          >
            <Modal.Header scloseButton>
              <Modal.Title className="text-info">
                <div className="text-center d-flex justify-center">
                  <h2 style={{ fontWeight: "800", color: "#2E2E48" }}>
                    <i class="bi bi-exclamation-triangle-fill icon"></i>Messages
                  </h2>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body
              className="rounded m-3"
              style={{
                maxHeight: "60vh",
                overflow: "scroll",
                backgroundColor: "white",
              }}
            >
              <p>
                NDA/MSA Ref# feild must be in proper format - NDA/MSA_
                Name_Date.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                // disabled={loading ? true : false}
                type="button"
                className="btn  custom-btn"
                onClick={handleErrorClose}
              >
                Ok
              </Button>
              {/* <Button className="btn btn-info" onClick={handleError}>
                No
              </Button> */}
            </Modal.Footer>
          </div>
        </Modal>

        {/** Delete PopUP  */}

        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          message="Are you sure you want to delete this item?"
        />
      </div>
    </>
  );
};

export default ClientMasterForm;
